export function getOrganizationFlags (organization) {
    return organization?.organizationFlags ?? organization?.flags ?? {};
}

/**
 * OAuth redirect URI validation is enabled for any organization with an id unless
 * oauthRedirectUriValidation is explicitly false. Reads organizationFlags with
 * flags as a fallback to match /api/init response shapes.
 */
export function isOAuthRedirectUriValidationEnabled (organization) {
    if (!organization?.id) {
        return false;
    }

    const organizationFlags = getOrganizationFlags(organization);

    if (organizationFlags.oauthRedirectUriValidation === false) {
        return false;
    }

    return true;
}
